import { useEffect, useState } from 'react'
import { ANALYTICS_PREFERENCE, analyticsAllowed, analyticsRoute, setAnalyticsPreference, trackSiteEvent } from '../utils/siteAnalytics'
import styles from './SiteAnalytics.module.css'

let lastPage = ''
export default function SiteAnalytics() {
  const [preference, setPreference] = useState(() => { try { return localStorage.getItem(ANALYTICS_PREFERENCE) || '' } catch { return 'decline' } })
  const [settings, setSettings] = useState(false)
  const [route, setRoute] = useState(analyticsRoute)
  useEffect(() => {
    const page = () => {
      const next = analyticsRoute(); setRoute(next)
      const key = `${next}:${window.location.pathname}:${new URL(window.location.href).searchParams.get('view') || ''}`
      if (!next || !analyticsAllowed() || key === lastPage) return
      lastPage = key; trackSiteEvent('page_view'); if (next === 'sample') trackSiteEvent('sample_open')
    }
    const changed = () => { try { setPreference(localStorage.getItem(ANALYTICS_PREFERENCE) || '') } catch { setPreference('decline') }; lastPage = ''; page() }
    const originalPush = history.pushState, originalReplace = history.replaceState
    const push: History['pushState'] = function(...args) { originalPush.apply(history, args); page() }
    const replace: History['replaceState'] = function(...args) { originalReplace.apply(history, args); page() }
    history.pushState = push; history.replaceState = replace
    window.addEventListener('radiant-assessment-state', page); window.addEventListener('popstate', page); window.addEventListener('radiant-analytics-preference', changed); window.addEventListener('storage', changed)
    page()
    return () => {
      if (history.pushState === push) history.pushState = originalPush
      if (history.replaceState === replace) history.replaceState = originalReplace
      window.removeEventListener('radiant-assessment-state', page); window.removeEventListener('popstate', page); window.removeEventListener('radiant-analytics-preference', changed); window.removeEventListener('storage', changed)
    }
  }, [])
  if (!route) return null
  const choose = (value: 'allow' | 'decline') => { setAnalyticsPreference(value); setSettings(false) }
  if ((!preference && ['landing', 'sample'].includes(route)) || settings) return <aside className={styles.notice} aria-label="Optional analytics preference">
    <div><strong>Help improve Radiant</strong><p>Allow optional analytics to count visits, broad device categories, and report or checkout interest. Your assessment answers and private notes are excluded.</p></div>
    <div className={styles.actions}><button onClick={() => choose('allow')}>Allow analytics</button><button onClick={() => choose('decline')}>Decline</button></div>
  </aside>
  return <div className={styles.settings}><button onClick={() => setSettings(true)}>Analytics preferences</button></div>
}
